import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type IconColor = 'primary' | 'white' | 'neutral' | 'danger' | 'light' | 'warning' | 'dark' | 'orange';
export type IconSize = 'lg' | 'md' | 's' | 'xs' | 'xxs' | 'xxxs';
export type IconMode = 'fill' | 'outline';

@Component({
  selector: 'cm-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'sizeClass()',
  },
})
export class IconComponent {
  public readonly name = input<string>('');
  public readonly mode = input<IconMode>('outline');
  public readonly color = input<IconColor>();
  public readonly size = input<IconSize>('lg');
  public readonly ariaHidden = input<boolean>(true);

  public readonly className = computed(() => this._getClassName());
  public readonly sizeClass = computed(() => this._getSizeClass());

  private _getClassName(): string {
    const iconClass = this.mode() === 'fill' ? 'material-icons' : 'material-symbols-outlined'
    const iconColor = this.color() || '';

    return `${iconClass} ${iconColor}`;
  }

  private _getSizeClass(): string {
    return `size-${this.size()}`;
  }
}
